import { z } from '@lucidlink/dto/z';
import { remapZodErrors } from '@lucidlink/uicore';
import { convertRateLimitToBytesPerSecond, convertToMiB } from '#services';
import { IP_V4_REGEX, IP_V6_REGEX, URL_REGEX, } from '../../../../constants/regex';
import { UNLIMITED_RATE_LIMIT_THRESHOLD } from '../../constants';
const RANGE_ERROR = 'cacheSize.range';
const RATE_LIMIT_RANGE_ERROR = 'rateLimit.range';
const TEAM_CACHE_LOCATION_ERROR = 'teamCache.location';
const cacheSizeValidatorSchema = z
    .number()
    .int()
    // 100 MiB
    .min(100, RANGE_ERROR)
    // 10 TiB
    .max(10485760, RANGE_ERROR);
export const cacheSizeValidator = (value, dependencyValue) => {
    const miB = convertToMiB(Number(value), dependencyValue);
    const res = cacheSizeValidatorSchema.safeParse(miB);
    return {
        isValid: res.success,
        errors: res.success ? [] : remapZodErrors(res.error.issues),
    };
};
const rateLimitStringValidatorSchema = z
    .string()
    .min(1, RATE_LIMIT_RANGE_ERROR);
const rateLimitNumberValidatorSchema = z
    .number()
    .int(RATE_LIMIT_RANGE_ERROR)
    .min(0, RATE_LIMIT_RANGE_ERROR)
    .max(UNLIMITED_RATE_LIMIT_THRESHOLD, RATE_LIMIT_RANGE_ERROR);
const validateRateLimitValue = (value, unit) => {
    // First validate string is not empty
    // "-" or "--" is parsed as empty string through
    // the html input type="number"
    const stringResult = rateLimitStringValidatorSchema.safeParse(value);
    if (!stringResult.success) {
        return {
            isValid: false,
            errors: remapZodErrors(stringResult.error.issues),
        };
    }
    const numericValue = Number(value);
    const rawInputResult = rateLimitNumberValidatorSchema.safeParse(numericValue);
    if (!rawInputResult.success) {
        return {
            isValid: false,
            errors: remapZodErrors(rawInputResult.error.issues),
        };
    }
    const bytesPerSecond = convertRateLimitToBytesPerSecond(numericValue, unit);
    const bytesResult = rateLimitNumberValidatorSchema.safeParse(bytesPerSecond);
    if (!bytesResult.success) {
        return {
            isValid: false,
            errors: remapZodErrors(bytesResult.error.issues),
        };
    }
    return { isValid: true, errors: [] };
};
export const rateLimitValidator = (value, dependencyValue) => {
    if (typeof value !== 'string') {
        return { isValid: false, errors: [] };
    }
    return validateRateLimitValue(value, dependencyValue);
};
const urlSchema = z.string().regex(URL_REGEX, TEAM_CACHE_LOCATION_ERROR);
const urlV4Schema = z.string().regex(IP_V4_REGEX, TEAM_CACHE_LOCATION_ERROR);
const urlV6Schema = z.string().regex(IP_V6_REGEX, TEAM_CACHE_LOCATION_ERROR);
export const teamCacheValidator = (value) => {
    const urlValidation = urlSchema.safeParse(value || '');
    const urlV4Validation = urlV4Schema.safeParse(value || '');
    const urlV6Validation = urlV6Schema.safeParse(value || '');
    const isValid = urlValidation.success ||
        urlV4Validation.success ||
        urlV6Validation.success;
    return {
        isValid,
        errors: isValid
            ? []
            : [
                {
                    code: TEAM_CACHE_LOCATION_ERROR,
                    message: '',
                    path: [],
                },
            ],
    };
};
